<ng-template #displayDash>
    <span>-</span>
</ng-template>

<div class="ui segment" [class.loading]="isLoading">
    <app-segment-header title="time-off-v3.type-store-form.payrollIntegration"></app-segment-header>

    <ui-banner variant="info" class="margin-y-3">
        <p [innerHTML]="payrollIntegrationNotice | translate"></p>
    </ui-banner>

    <div class="flex row" *ngIf="isPaid !== timeWorkedValue">
        <div class="max-width-field grow">
            <mat-form-field class="field">
                <mat-label appRemoveAriaOwns>{{
                    'time-off-v3.type-store-form.connectToAPayrollIncomeType' | translate
                }}</mat-label>
                <mat-select
                    name="incomeTypeId"
                    [placeholder]="'time-off-v3.type-store-form.selectAnOption' | translate"
                    [(ngModel)]="timeOffType.incomeTypeId"
                    #incomeTypeIdVar="ngModel"
                    [disabled]="incomeTypeFieldDisabled"
                    (selectionChange)="refreshSelectedIncomeType()"
                >
                    <mat-select-trigger> {{ selectedIncomeType?.displayName ?? '' }} </mat-select-trigger>
                    <mat-option [value]="null">
                        {{ 'time-off-v3.type-store-form.selectAnOption' | translate }}</mat-option
                    >
                    <mat-option
                        *ngFor="let incomeType of selectableIncomeTypes"
                        [value]="incomeType.id"
                        class="multi-line"
                    >
                        <div class="income-type-title">{{ incomeType.displayName }}</div>
                        <div class="subscript">{{ incomeType.description }}</div>
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="incomeTypeIdVar.invalid">{{ incomeTypeIdVar.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
        <div *ngIf="timeOffType.incomeTypeId" class="view-income-type-link flex middle">
            <a [routerLink]="['/payroll', 'additional-incomes', timeOffType.incomeTypeId]" target="_blank">{{
                'time-off-v3.type-store-form.viewIncomeTypeDetails' | translate
            }}</a>
        </div>
    </div>
    <div class="flex tax-display" *ngIf="timeOffType.incomeTypeId && selectedIncomeType">
        <div class="max-width-field">
            <div class="field bordered padding-2">
                <div class="margin-bottom-2">
                    <div class="income-type-title">{{ selectedIncomeType.displayName }}</div>
                    <div class="income-description-label">
                        {{ 'time-off-v3.type-store-form.description' | translate }}
                    </div>
                    <div class="description" *ngIf="selectedIncomeType?.description?.length; else displayDash">
                        {{ selectedIncomeType.description }}
                    </div>
                </div>

                <div class="margin-bottom-2">
                    <div class="margin-bottom-1">
                        <label>{{ 'time-off-v3.type-store-form.taxesTitle' | translate }}</label>
                    </div>
                    <app-additional-income-taxation
                        [companyAdditionalIncome]="selectedIncomeType"
                    ></app-additional-income-taxation>
                </div>

                <div class="margin-bottom-2">
                    <div class="margin-bottom-1">
                        <label>{{ 'payroll.additional-incomes.taxForms' | translate }}</label>
                    </div>
                    <div class="inline field">
                        <label>{{ 'payroll.additional-incomes.t4' | translate }}</label>
                        <span *ngIf="selectedIncomeType?.t4Boxes?.length">
                            <span *ngFor="let t4Box of selectedIncomeType.t4Boxes; last as isLast"
                                >{{ 'time-off-v3.type-store-form.taxBox' | translate }} {{ t4Box.boxNumber
                                }}<span *ngIf="!isLast">,&nbsp;</span>
                            </span>
                        </span>

                        <span *ngIf="!selectedIncomeType?.t4Boxes?.length">
                            {{ 'time-off-v3.type-store-form.na' | translate }}</span
                        >
                    </div>

                    <div class="inline field" *ngIf="hasQcPayrollFeature">
                        <label>{{ 'payroll.additional-incomes.rl1' | translate }}</label>
                        <span *ngIf="selectedIncomeType?.rl1Boxes?.length">
                            <span *ngFor="let rl1Box of selectedIncomeType.rl1Boxes; last as isLast"
                                >{{ 'time-off-v3.type-store-form.taxBox' | translate }} {{ rl1Box.code
                                }}<span *ngIf="!isLast">,&nbsp;</span>
                            </span>
                        </span>

                        <span *ngIf="!selectedIncomeType?.rl1Boxes?.length">
                            {{ 'time-off-v3.type-store-form.na' | translate }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
